export default __webpack_public_path__ + "static/media/LINKEDIN_ico.4112cd29.svg";